import axios from 'axios';
import store from '@/store/store';
import router from '@/router';

export default () => {
  const instance = axios.create({
    baseURL: `${store.getters.endpoint}/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`,
    },
  });

  instance.interceptors.response.use(
    (response) => { return response; }, //eslint-disable-line
    (error) => {
      if (error.response && error.response.status === 401) {
        store.dispatch('logout');
        router.push({ name: 'Login' });
      }
      return Promise.reject(error);
    },
  );

  return instance;
};
